export function info (message: string, context: any = null) {
    console.log(`[INFO] ${message}`)
}
